import type { ChowRole } from '../../../lib/actor'

/** Normalize a `?role=` value from a CTA link to a known ChooseChow role. */
export const normalizeRoleParam = (value: string | null | undefined): ChowRole | null => {
  switch ((value ?? '').toLowerCase()) {
    case 'customer':
    case 'eater':
    case 'buyer':
      return 'customer'
    case 'chef':
    case 'vendor':
    case 'cook':
    case 'kitchen':
      return 'chef'
    default:
      return null
  }
}
